import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';

export default function Ratgeber() {
  // TODO: Später mit CMS oder API ersetzen
  const articles = [
    {
      id: 1,
      slug: 'pflegegrad-beantragen-itzehoe',
      title: 'Pflegegrad beantragen in Itzehoe - Schritt für Schritt Anleitung 2025',
      excerpt: 'Alles was Sie über die Beantragung eines Pflegegrades wissen müssen - von der Antragstellung bis zur Begutachtung durch den MDK.',
      category: 'Ratgeber',
      date: '2025-01-15',
      readTime: '8 Min',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800'
    },
    // Weitere Artikel hier hinzufügen
  ];

  return (
    <main id="main-content" className="pt-32 pb-20">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <div className="inline-block px-4 py-2 bg-[#1A52D8]/5 rounded-full text-[#1A52D8] font-medium text-sm mb-6">
            Ratgeber & Wissen
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e293b] mb-6">
            Pflege-Ratgeber für Itzehoe & Umgebung
          </h1>
          <p className="text-xl text-[#64748b] leading-relaxed">
            Hilfreiche Informationen rund um ambulante Pflege, Pflegegrade, Kosten und 
            praktische Tipps für Angehörige.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <article 
              key={article.id}
              className="group bg-white rounded-2xl overflow-hidden border border-[#e2e8f0] hover:shadow-xl hover:border-[#1A52D8]/30 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative overflow-hidden aspect-video">
                <img 
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-[#1A52D8] text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-[#94a3b8] mb-3">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    <time dateTime={article.date}>
                      {new Date(article.date).toLocaleDateString('de-DE', { 
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}
                    </time>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    <span>{article.readTime}</span>
                  </div>
                </div>

                <h2 className="text-xl font-bold text-[#1e293b] mb-3 group-hover:text-[#1A52D8] transition-colors line-clamp-2">
                  {article.title}
                </h2>

                <p className="text-[#64748b] mb-4 line-clamp-3">
                  {article.excerpt}
                </p>

                <Link 
                  to={`/ratgeber/${article.slug}`}
                  className="inline-flex items-center gap-2 text-[#1A52D8] font-semibold hover:gap-3 transition-all"
                >
                  Artikel lesen
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* Empty State wenn keine Artikel */}
        {articles.length === 0 && (
          <div className="text-center py-20">
            <p className="text-xl text-[#64748b]">
              Neue Artikel folgen in Kürze...
            </p>
          </div>
        )}

        {/* Newsletter CTA (Optional) */}
        <div className="mt-20 max-w-2xl mx-auto p-8 bg-gradient-to-br from-[#1A52D8] to-[#23D3D3] rounded-2xl text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Bleiben Sie informiert
          </h3>
          <p className="text-white/90 mb-6">
            Erhalten Sie hilfreiche Pflege-Tipps und Neuigkeiten direkt per E-Mail.
          </p>
          <Link to="/kontakt">
            <button className="bg-white text-[#1A52D8] px-8 py-3 rounded-full font-semibold hover:bg-white/90 transition-colors">
              Jetzt kontaktieren
            </button>
          </Link>
        </div>
      </div>
    </main>
  );
}
